<template>
    <div class="apply-page">
        <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
                <span>数据价值评估申请</span>
                <span style="float:right; color:#909399; font-size:13px;">
                    带 <span style="color:red;">*</span> 为必传材料，所有必传材料均需公司盖章，支持 PDF / JPG / PNG
                </span>
            </div>

            <!-- 必传材料 -->
            <div class="section-title">必传材料</div>
            <div class="upload-grid">
                <div v-for="item in requiredItems" :key="item.key" class="upload-card">
                    <div class="upload-label">
                        <span class="required-star">*</span>{{ item.label }}
                    </div>
                    <el-upload
                        class="uploader"
                        drag action="#" :auto-upload="false"
                        :on-change="(f, fl) => handleFileChange(f, fl, item.key)"
                        :on-remove="(f, fl) => handleFileRemove(f, fl, item.key)"
                        :file-list="fileLists[item.key]"
                        :limit="5" :multiple="true"
                        accept=".pdf,.jpg,.jpeg,.png">
                        <div class="upload-inner">
                            <i class="el-icon-upload upload-icon"></i>
                            <div class="upload-text">点击或拖拽上传</div>
                            <div class="upload-hint">PDF / JPG / PNG，≤{{ fileSizeLimit }}M</div>
                        </div>
                    </el-upload>
                    <div v-if="fileLists[item.key].length" class="file-count">
                        已选 {{ fileLists[item.key].length }} 个文件
                    </div>
                </div>
            </div>

            <!-- 非必传材料 -->
            <div class="section-title" style="margin-top:30px;">
                选填材料 <span style="font-weight:normal; color:#909399; font-size:13px;">（以下材料非必传）</span>
            </div>
            <div class="upload-grid">
                <div v-for="item in optionalItems" :key="item.key" class="upload-card optional">
                    <div class="upload-label optional-label">{{ item.label }}</div>
                    <el-upload
                        class="uploader"
                        drag action="#" :auto-upload="false"
                        :on-change="(f, fl) => handleFileChange(f, fl, item.key)"
                        :on-remove="(f, fl) => handleFileRemove(f, fl, item.key)"
                        :file-list="fileLists[item.key]"
                        :limit="5" :multiple="true"
                        accept=".pdf,.jpg,.jpeg,.png">
                        <div class="upload-inner">
                            <i class="el-icon-upload upload-icon optional-icon"></i>
                            <div class="upload-text">点击或拖拽上传</div>
                            <div class="upload-hint">PDF / JPG / PNG，≤{{ fileSizeLimit }}M</div>
                        </div>
                    </el-upload>
                    <div v-if="fileLists[item.key].length" class="file-count">
                        已选 {{ fileLists[item.key].length }} 个文件
                    </div>
                </div>
            </div>
        </el-card>

        <!-- 必传进度条 -->
        <el-card class="box-card" shadow="never" style="margin-top:16px;">
            <div style="display:flex; align-items:center; gap:16px;">
                <span style="white-space:nowrap; font-size:13px; color:#606266;">必传材料完成度：</span>
                <el-progress
                    :percentage="requiredProgress"
                    :color="requiredProgress === 100 ? '#67C23A' : '#409EFF'"
                    style="flex:1;"
                />
                <span style="white-space:nowrap; font-size:13px; color:#606266;">
                    {{ uploadedRequiredCount }} / {{ requiredItems.length }}
                </span>
            </div>
        </el-card>

        <div style="margin-top:24px; text-align:center;">
            <el-button type="danger" size="medium" @click="close('/DataValue')" style="width:90px;">
                取消
            </el-button>
            <el-button type="primary" size="medium" @click="submitApply"
                :disabled="isSubmitDisabled" style="width:160px; margin-left:20px;">
                {{ isSubmitting ? '提交中...' : '提交价值评估申请' }}
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DataValueApply',
    data() {
        return {
            fileSizeLimit: 100,
            registrationId: '',
            userId: '',
            isSubmitting: false,
            loadingInstance: null,
            fileLists: {
                businessLicense: [],
                assetCertificate: [],
                qualityReport: [],
                legalOpinion: [],
                companyProfile: [],
                interviewRecord: [],
                auditReport3year: [],
                auditReport3month: [],
                companyCharter: [],
                assetChecklist: [],
                salesContract: [],
                feasibilityReport: [],
                intellectualProperty: [],
                otherMaterials: []
            },
            uploadedUrls: {
                businessLicense: [],
                assetCertificate: [],
                qualityReport: [],
                legalOpinion: [],
                companyProfile: [],
                interviewRecord: [],
                auditReport3year: [],
                auditReport3month: [],
                companyCharter: [],
                assetChecklist: [],
                salesContract: [],
                feasibilityReport: [],
                intellectualProperty: [],
                otherMaterials: []
            },
            requiredItems: [
                { key: 'businessLicense',   label: '营业执照' },
                { key: 'assetCertificate',  label: '数据资产证书' },
                { key: 'qualityReport',     label: '质量评价报告' },
                { key: 'legalOpinion',      label: '合规法律意见书' },
                { key: 'companyProfile',    label: '公司简介' },
                { key: 'interviewRecord',   label: '访谈记录' },
                { key: 'auditReport3year',  label: '近三年审计报告或财务报表' },
                { key: 'auditReport3month', label: '近三个月审计报告或财务报表' },
                { key: 'companyCharter',    label: '公司章程' },
                { key: 'assetChecklist',    label: '数据资产查验表' }
            ],
            optionalItems: [
                { key: 'salesContract',        label: '数据销售合同' },
                { key: 'feasibilityReport',    label: '可行性研究报告（数据相关）' },
                { key: 'intellectualProperty', label: '知识产权相关（专利、软著）' },
                { key: 'otherMaterials',       label: '其他补充材料' }
            ]
        }
    },
    created() {
        this.registrationId = this.$route.query.registrationId || '';
        this.userId = this.$route.query.userId || '';
    },
    computed: {
        uploadedRequiredCount() {
            return this.requiredItems.filter(i => this.fileLists[i.key].length > 0).length;
        },
        requiredProgress() {
            return Math.round(this.uploadedRequiredCount / this.requiredItems.length * 100);
        },
        isSubmitDisabled() {
            if (this.isSubmitting) return true;
            return this.requiredItems.some(i => this.fileLists[i.key].length === 0);
        }
    },
    methods: {
        handleFileChange(file, fileList, key) {
            const allowedExt = ['.pdf', '.jpg', '.jpeg', '.png'];
            const extOk = allowedExt.some(e => file.name.toLowerCase().endsWith(e));
            if (!extOk) {
                this.$message.error('只支持 PDF、JPG、PNG 格式');
                fileList.splice(fileList.indexOf(file), 1);
                return;
            }
            if (file.raw.size > this.fileSizeLimit * 1024 * 1024) {
                this.$message.error(`文件大小不能超过 ${this.fileSizeLimit} MB`);
                fileList.splice(fileList.indexOf(file), 1);
                return;
            }
            this.fileLists[key] = fileList;
        },
        handleFileRemove(_file, fileList, key) {
            this.fileLists[key] = fileList;
        },
        async submitApply() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            this.loadingInstance = this.$loading({
                lock: true,
                text: '正在上传文件，请勿关闭或刷新页面...',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
                const allKeys = [...this.requiredItems, ...this.optionalItems].map(i => i.key);
                for (const key of allKeys) {
                    this.uploadedUrls[key] = [];
                    for (const file of this.fileLists[key]) {
                        const url = await this.uploadSingleFile(file, key);
                        this.uploadedUrls[key].push(url);
                    }
                }
                const resp = await this.$axios.post('/web/dataValue/submit', {
                    registrationId: this.registrationId,
                    ...this.uploadedUrls
                });
                if (resp.data && resp.data.status === 200) {
                    this.loadingInstance.close();
                    this.$confirm('申请提交成功！', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        showCancelButton: false
                    }).then(() => this.close('/DataValue'));
                } else {
                    this.$message.error('提交失败: ' + (resp.data.msg || '未知错误'));
                }
            } catch (err) {
                this.$message.error('上传或提交失败: ' + (err.message || '未知错误'));
            } finally {
                this.isSubmitting = false;
                if (this.loadingInstance) this.loadingInstance.close();
            }
        },
        uploadSingleFile(file, type) {
            const formData = new FormData();
            formData.append('file', file.raw || file);
            formData.append('registrationId', this.registrationId);
            formData.append('type', type);
            return this.$axios.post('/web/dataValue/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(resp => {
                if (resp.data && resp.data.status === 200) return resp.data.object;
                throw new Error(resp.data.msg || '上传失败');
            });
        },
        close(targetPage = '/DataValue') {
            const fullPath = this.$route.fullPath;
            const currentPath = this.$route.path;
            if (currentPath !== targetPage) {
                this.$router.push(targetPage).then(() => {
                    setTimeout(() => this.closeTab(fullPath), 100);
                }).catch(() => this.closeTab(fullPath));
            } else {
                this.closeTab(fullPath);
            }
        },
        closeTab(fullPath) {
            this.$emit('close-tab', fullPath);
            let parent = this.$parent;
            while (parent) {
                if (typeof parent.removeTab === 'function') {
                    parent.removeTab(fullPath);
                    break;
                }
                parent = parent.$parent;
            }
        }
    }
}
</script>

<style scoped>
.apply-page {
    padding: 16px;
    background-color: #f5f7fa;
    min-height: 100%;
}

.box-card {
    border-radius: 8px;
}

.box-card >>> .el-card__header {
    background-color: #f0f2f5;
    font-weight: bold;
    font-size: 15px;
}

.section-title {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 16px;
    padding-left: 10px;
    border-left: 4px solid #409EFF;
}

.upload-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
}

.upload-card {
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 12px;
    transition: box-shadow 0.2s;
}

.upload-card:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.upload-card.optional {
    border-style: dashed;
    background: #fafafa;
}

.upload-label {
    font-size: 13px;
    color: #303133;
    font-weight: 600;
    margin-bottom: 8px;
    line-height: 1.4;
    min-height: 36px;
}

.optional-label {
    color: #606266;
    font-weight: normal;
}

.required-star {
    color: red;
    margin-right: 3px;
}

.upload-card >>> .el-upload {
    width: 100%;
}

.upload-card >>> .el-upload-dragger {
    width: 100%;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upload-inner {
    text-align: center;
}

.upload-icon {
    font-size: 22px;
    color: #409EFF;
    display: block;
}

.optional-icon {
    color: #909399;
}

.upload-text {
    font-size: 12px;
    color: #606266;
    margin-top: 4px;
}

.upload-hint {
    font-size: 11px;
    color: #909399;
    margin-top: 2px;
}

.file-count {
    margin-top: 6px;
    font-size: 12px;
    color: #67C23A;
    text-align: center;
}

.clearfix:before, .clearfix:after {
    display: table;
    content: "";
}
.clearfix:after { clear: both; }
</style>
